import { render, staticRenderFns } from "./dynamic-site-menu.vue?vue&type=template&id=e3348740&scoped=true&"
import script from "./dynamic-site-menu.vue?vue&type=script&lang=js&"
export * from "./dynamic-site-menu.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-site-menu.vue?vue&type=style&index=0&id=e3348740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3348740",
  null
  
)

export default component.exports